import { useState, useMemo } from "react";
// Material-UI
import { Grid } from "@mui/material";
//sections
import LandingPage from "./LandingPage";
import LandingLocation from "./LandingLocation";
// Components
import BodyLayer from "@/Layouts/components/Layers/BodyLayer";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";
import ScrollSideBar from "@/Layouts/components/SideBars/ScrollSideBar/ScrollSideBar";
import ContentScrollable from "@/Layouts/components/ContentScrollable";
// Styles
import "@/User/assets/styles/styles.css";

function UserPreferencesContainer() {
	const [selectedId, setSelectedId] = useState<string>("");
	const menuItems = useMemo(
		() => [
			{
				_id: "1",
				label: "Landing Location",
			},
			{
				_id: "2",
				label: "Landing page",
			},
		],
		[]
	);

	const handleItemClick = (event: React.MouseEvent<HTMLElement>) => {
		setSelectedId(event.currentTarget.id);
	};

	return (
		<BodyLayer>
			<RoundedBox
				sx={{
					minHeight: "600px",
				}}
			>
				<Grid container spacing={3}>
					<Grid item xs={2}>
						<ScrollSideBar
							position="sticky"
							top="120px"
							menus={menuItems}
							selected={selectedId || "1"}
							showBy="label"
							scrollBy="locationId"
							defaultSelection
							onActionClick={handleItemClick}
						/>
					</Grid>

					<Grid item xs={10}>
						<ContentScrollable scrollTo={selectedId}>
							<Grid container direction="column" rowGap={2}>
								<LandingLocation />
								<LandingPage />
							</Grid>
						</ContentScrollable>
					</Grid>
				</Grid>
			</RoundedBox>
		</BodyLayer>
	);
}

export default UserPreferencesContainer;
